import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let ShortTextDesign = class ShortTextDesign extends Vue {
    render(h) {
        const that = this;
        return h('a-input', { props: {
                disabled: true,
                placeholder: that.$t('cloudpivot.form.dataitem.InputPlaceholder').toString(),
            } });
    }
};
tslib_1.__decorate([
    Prop({ default: {} })
], ShortTextDesign.prototype, "control", void 0);
ShortTextDesign = tslib_1.__decorate([
    Component({ name: 'ShortTextDesign' })
], ShortTextDesign);
export default ShortTextDesign;
